export enum OrderType {
  Reservation = 'reservation',
  Takeaway = 'takeaway',
  Hotel = 'hotel'
}
